export enum ErrorStateAction {
  RELOAD_PAGE = 'RELOAD PAGE'
}

export enum ErrorStateTitle {
  SOMETHING_WENT_WRONG = 'Something went wrong...'
}
